import { escapeHtml } from '../escape.js';
import { editAttr, itemCollection, itemStr, labeledIntro, list, sectionOpen, str } from './helpers.js';
import type { JsonValueT, PatternSectionT } from '../../schema/index.js';

function scalarItemText(item: JsonValueT, key: string): string {
  if (item === null || typeof item !== 'object' || Array.isArray(item)) return '';
  const value = item[key];
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return String(value);
  return '';
}

/** stats_strip — native stats shape with items/number compatibility fallback. */
export function renderStatsStrip(section: PatternSectionT): string {
  const heading = str(section.fields, 'heading');
  let sourceKey = 'stats';
  let valueKey = 'value';
  let entries = list(section.fields, sourceKey);
  if (entries.length === 0) {
    sourceKey = 'items';
    valueKey = 'number';
    entries = list(section.fields, sourceKey);
  }
  const stats = entries
    .map((item, index) => {
      const value = scalarItemText(item, valueKey);
      const label = itemStr(item, 'label');
      if (!value && !label) return '';
      const itemPath = `/${sourceKey}/${index}`;
      const lines = [`    <div class="ve-stats-strip__stat"${editAttr(section, itemPath)}>`];
      if (value) lines.push(`      <strong class="ve-stats-strip__value">${escapeHtml(value)}</strong>`);
      if (label) lines.push(`      <span class="ve-stats-strip__label">${escapeHtml(label)}</span>`);
      lines.push('    </div>');
      return lines.join('\n');
    })
    .filter(Boolean)
    .join('\n');

  const sourcePath = `/${sourceKey}`;
  const parts: string[] = [
    sectionOpen(section),
    ...labeledIntro(section, 'stats-strip', heading),
    itemCollection(section, 'div', 've-stats-strip__items', sourcePath, stats),
    '</section>',
  ];
  return parts.join('\n');
}
